export const EventType = Object.freeze({
  HEARTBEAT: 'HEARTBEAT',
  ERROR: 'ERROR',
  SMS: 'SMS',
  CALLBACK: 'CALLBACK',
})
